import { VdsBadgePill } from '@volt/volt-extended-components-react';
import { useTranslation } from 'react-i18next';

interface BadgeAudibleProps {
  isAudible: boolean;
}

export function BadgeAudible({ isAudible }: BadgeAudibleProps) {
  const { t } = useTranslation();

  return (
    <VdsBadgePill
      // The following styles are necessary to apply to the vds wrapper element or the badge sits at the top of the invisible parent element.
      style={{ display: 'flex', alignItems: 'center' }}
      icon={isAudible ? 'unmute' : 'mute'}
      value={isAudible ? t('Audible') : t('NotAudible')}
      statusColor={isAudible ? 'healthy' : 'neutral'}
      size="medium"
    />
  );
}

export default BadgeAudible;
